import { OctTable } from "@oceantech/oceantech-ui";
import React, { useContext, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import AutocompleteV2 from "../../component/AutocompleteObjectV2";
import TextValidator from "../../component/TextValidator";
import {
  BTN_ACTIONS,
  CODE_SUCCESS,
  ERROR_MESSAGE,
  MESSAGE,
  textSystem,
} from "../../utils/Constant";
import {
  EVALUATE_STATUS,
  RESULT,
} from "../constants/reportDetailModal";
import { saveCriteria } from "../services/ReportEvaluation";

import { AppContext } from "../../appContext/AppContext";
import { IFile, IViewFile } from "../../models/models";
import {
  handleDownloadFileUtil,
  handleUploadFileUtil,
  handleViewFileUtil,
} from "../../utils/FileUtils";
import ViewFile from "../modals/ViewFile";
import { FileActions } from "./FileActions";
import {ICriteriaModalProps} from "../models/ReportEvaluationModels";
import {useReportEvaluationContext} from "../context/ReportEvaluationContext";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";

const CriteriaTable = (props: ICriteriaModalProps) => {
  const {
    dataTable,
    setDataTable,
    objectSearch,
    setObjectSearch,
    configTable,
    handleDoubleClick,
    tableCache,
    setTableCache,
    reload,
    setReload,
  } = props;
  const { setIsLoading } = useContext(AppContext);
  const {isView} = useReportEvaluationContext();
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [touched, setTouched] = useState<{ [key: string]: boolean }>({});
  const [viewFile, setViewFile] = useState<IViewFile>({
    open: false,
    file: null,
  });

  const validateFields = () => {
    const newErrors: { [key: string]: string } = {};
    let valid = true;

    dataTable?.forEach((row: any, index: number) => {
      if (!row.pointSelfAssessment) {
        newErrors[`pointSelfAssessment_${index}`] = MESSAGE.REQUIRED;
        valid = false;
      }

      if (!row.evidence) {
        newErrors[`evidence_${index}`] = MESSAGE.REQUIRED;
        valid = false;
      }
    });

    setErrors(newErrors);
    return valid;
  };

  const handleViewFile = async (file: IFile) => {
    const viewFile = await handleViewFileUtil(file, setIsLoading);
    if (viewFile) {
      setViewFile(viewFile);
    }
  };

  const handleDownloadFile = async (file: IFile) => {
    await handleDownloadFileUtil(file, setIsLoading);
  };

  const handleChangeTable = async (
    index: number,
    value: any,
    field: string,
    row: any
  ) => {
    const newDataTable = [...dataTable];

    if (field === "evidence") {
      newDataTable[index][field] = await handleUploadFileUtil(
        value,
        setIsLoading
      );
    } else if (field === "status") {
      newDataTable[index][field] = value
        ? EVALUATE_STATUS.EVALUATED.code
        : EVALUATE_STATUS.NOT_RATE_YET.code;
    } else {
      newDataTable[index][field] = value;
    }

    setDataTable(newDataTable);
    const key = objectSearch?.level;
    setTableCache((prev: any) => ({
      ...prev,
      [key]: newDataTable,
    }));

    setTouched((prev) => ({
      ...prev,
      [`${field}_${index}`]: true,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const flattenData = Object.values(tableCache)?.flatMap((item: any) => item);
    const dataRequest = dataTable?.map((item: any) => {
      return {
        id: item?.id,
        criteriaSubsectionId: item?.criteriaSubsectionId,
        planCriteriaId: objectSearch?.planCriteriaId,
        fileId: item?.evidence?.id,
        fileName: item?.evidence?.name,
        pointSelfAssessment: item?.pointSelfAssessment?.id,
        conclusionAssessment: item?.conclusionAssessment?.id,
        comment: item?.comment,
        status: item?.status,
      };
    });
    setIsLoading(true);
    try {
      const { data } = await saveCriteria(dataRequest);
      if (data?.code === CODE_SUCCESS) {
        toast.success("Lưu thành công");
        setReload(!reload);
      }
    } catch (error) {
      console.error("error", error);
      toast.error(ERROR_MESSAGE);
    } finally {
      setIsLoading(false);
    }
  };

  const criteriaColumns = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: "50px",
      },
      cellStyle: {
        width: "50px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => <span>{stt}</span>,
    },
    {
      name: "Thao tác",
      field: "",
      headerStyle: {
        width: "100px",
        minWidth: "100px",
      },
      cellStyle: {
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex justify-content-center gap-3">
          <CustomIconButton
            variant="view"
            onClick={() => handleDoubleClick(BTN_ACTIONS.VIEW, row)}
          >
            <i className="bi bi-eye-fill text-gray-700"></i>
          </CustomIconButton>

          <CustomIconButton
            variant="edit"
            onClick={() => handleDoubleClick(BTN_ACTIONS.EDIT, row)}
          >
            <i className="bi bi-pencil-square text-primary"></i>
          </CustomIconButton>
        </div>
      ),
    },
    {
      name: "Tên tiểu mục",
      field: "subsectionName",
      headerStyle: {
        width: "600px",
      },
      cellStyle: {
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        // <div onDoubleClick={() => handleDoubleClick(row)}>
          <span className={`${row?.conclusionAssessment ? "text-navy" : ""}`}>
            {row?.subsectionName}
          </span>
        // </div>
      ),
    },
    {
      name: "Mức tiểu mục",
      field: "subsectionName",
      headerStyle: {
        width: "120px",
      },
      cellStyle: {
        ...textSystem,
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => 3,
    },
    {
      name: "Tên tiêu chí",
      field: "subsectionName",
      headerStyle: {
        width: "120px",
      },
      cellStyle: {
        ...textSystem,
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => "C1.1",
    },
  ];

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <OctTable
          id="searchCriteria"
          className={`table-background-th spaces h-calc-vh-242`}
          data={dataTable}
          columns={criteriaColumns}
          searchObject={objectSearch}
          setSearchObject={setObjectSearch}
          fixedColumnsCount={-1}
          noToolbar={true}
          totalPages={configTable.totalPages}
          totalElements={configTable.totalElements}
          numberOfElements={configTable.numberOfElements}
          isShowSelection={false}
          clearToolbar={true}
          noPagination={true}
        />
        <div className="position-fixed bottom-0 end-0 p-3 w-100 d-flex justify-content-end border-top">
          {!isView && (
            <Button className="btn-fill min-w-100px" type="submit">
              Lưu
            </Button>
          )}
        </div>
      </form>

      {viewFile?.open && (
        <ViewFile
          show={viewFile?.open}
          file={viewFile?.file}
          onHide={() => setViewFile({ open: false, file: null })}
        />
      )}
    </div>
  );
};

export default CriteriaTable;
